import { _notificationTemplate } from "../constants/api";


export const getNotificationTemplates = async () => {
  try {
 
    const response= await fetch(`${_notificationTemplate}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    const responseJSON = await response.json();

    return responseJSON;
  } catch (error) {
    console.log('Error occured in the user register api ==> ', error);
  }
};